import { render, staticRenderFns } from "./IframeWidgetPreview.vue?vue&type=template&id=49e63767&scoped=true"
import script from "./IframeWidgetPreview.vue?vue&type=script&lang=js"
export * from "./IframeWidgetPreview.vue?vue&type=script&lang=js"
import style0 from "./IframeWidgetPreview.vue?vue&type=style&index=0&id=49e63767&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e63767",
  null
  
)

export default component.exports